module.exports = new __parcel__URL__("77231_sq.1c539764.jpg").toString();